export default "__VITE_ASSET__Bj6WvYb6__"